import { registerLocaleData } from "@angular/common";
import localeEN from "@angular/common/locales/en";
import localeNL from "@angular/common/locales/nl";
import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

registerLocaleData(localeNL, "nl-NL");
registerLocaleData(localeEN, "en-GB");

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
